package org.example.project.enginekalender

import androidx.compose.runtime.Composable
import org.example.project.dashboard.DashboardTheme
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

fun kontaktDisplayName(user: All): String =
    listOf(user.vorname, user.nachname)
        .filter { it.isNotBlank() }
        .joinToString(" ")
        .ifBlank { user.name }
        .ifBlank { user.email }
        .ifBlank { user.id }

fun formatGermanDate(isoDate: String): String {
    val parts = isoDate.split("-")
    if (parts.size != 3) return isoDate
    val year = parts[0]
    val month = parts[1].toIntOrNull() ?: return isoDate
    val day = parts[2].toIntOrNull() ?: return isoDate
    val monthName = kalenderMonthName(month)
    return "${day.toString().padStart(2, '0')}. $monthName $year"
}

@Composable
fun TerminField(label: String, content: @Composable () -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(8.px)
        }
    }) {
        Span({
            style {
                color(DashboardTheme.TEXT_MUTED)
                fontSize(13.px)
                fontWeight("600")
            }
        }) { Text(label) }
        content()
    }
}

fun StyleScope.terminInputStyle() {
    width(100.percent)
    minHeight(36.px)
    padding(0.px, 12.px)
    boxSizing("border-box")
    color(Color.white)
    backgroundColor(Color("rgba(23, 26, 32, 0.38)"))
    borderRadius(8.px)
    border {
        width(1.px)
        style(LineStyle.Solid)
        color(Color("#303645"))
    }
}
